import script from "./MxsGdpr.vue?vue&type=script&setup=true&lang=ts"
export * from "./MxsGdpr.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__